import { graphql, useStaticQuery } from 'gatsby';
import { IGatsbyImageData } from 'gatsby-plugin-image';

export type OneLinerVariant = 1 | 2 | 3 | 4 | 5;

interface OneLinerBackgroundQuery {
  variant1: {
    gatsbyImageData: IGatsbyImageData;
  };
  variant2: {
    gatsbyImageData: IGatsbyImageData;
  };
  variant3: {
    gatsbyImageData: IGatsbyImageData;
  };
  variant4: {
    gatsbyImageData: IGatsbyImageData;
  };
  variant5: {
    gatsbyImageData: IGatsbyImageData;
  };
}

export const useOneLinerBackgroundVariant = (variant?: OneLinerVariant): IGatsbyImageData | undefined => {
  const data = useStaticQuery<OneLinerBackgroundQuery>(graphql`
    {
      variant1: contentfulAsset(contentful_id: { eq: "sVyORSQiRI3yRtm3VJ8lZ" }) {
        gatsbyImageData(layout: FULL_WIDTH, placeholder: BLURRED, width: 1800)
      }
      variant2: contentfulAsset(contentful_id: { eq: "7ewIYRhJ4ADgHTtCL4qfEE" }) {
        gatsbyImageData(layout: FULL_WIDTH, placeholder: BLURRED, width: 1800)
      }
      variant3: contentfulAsset(contentful_id: { eq: "3GxEHYfwUKQWeuMW3jhVDd" }) {
        gatsbyImageData(layout: FULL_WIDTH, placeholder: BLURRED, width: 1800)
      }
      variant4: contentfulAsset(contentful_id: { eq: "9woHPnTcboFirnTgpbWcH" }) {
        gatsbyImageData(layout: FULL_WIDTH, placeholder: BLURRED, width: 1800)
      }
      variant5: contentfulAsset(contentful_id: { eq: "11BPyEqMI9ulTsn73KmliH" }) {
        gatsbyImageData(layout: FULL_WIDTH, placeholder: BLURRED, width: 1800)
      }
    }
  `);

  if (!variant) return undefined;

  const variantMap: Record<OneLinerVariant, IGatsbyImageData> = {
    1: data.variant1.gatsbyImageData,
    2: data.variant2.gatsbyImageData,
    3: data.variant3.gatsbyImageData,
    4: data.variant4.gatsbyImageData,
    5: data.variant5.gatsbyImageData,
  };

  return variantMap[variant];
};
